import { CaretRightOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';
import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import AppearanceSettings from '../AppearanceSettings';
import ChartSettings from '../Chart/ChartSettings';
import ObjectLayer from '../ObjectLayer';
import OpacitySettings from '../OpacitySettings';
import TextEditor from '../TextEditor';
import TransformComponent from '../TransformComponent';

import {
  ACTIVE_SELECTION,
  CHART,
  CUSTOM_GROUP_ID,
  CUSTOM_TEXT,
  GROUP,
  IMAGE,
  ITEXT,
  TEXTBOX,
  TEXT_COMPONENT,
} from '../../utils';
import ShadowSettings from '../ShadowSettings';
import './styles.scss';

import { customSetting } from '../../fabric_obj/customObj/handle/index';

const { Panel } = Collapse;

const ComponentSettings = () => {
  const activeType = useSelector((state) => state.board.activeType);
  const objectName = useSelector((state) => state.board.objectName);
  const activeObj = window.canvas.getActiveObject();

  const hasColorSettings = () => {
    if (!window.canvas || !activeObj || [IMAGE, ACTIVE_SELECTION].includes(activeObj.type)) return false;

    const isText = [TEXTBOX, ITEXT, CUSTOM_TEXT].includes(activeType);
    const isGroup = [GROUP].includes(activeType);
    if (isGroup && activeObj.colorSetting) {
      return true;
    }
    if (isText || (isGroup && activeObj?._objects?.length !== 1)) {
      return false;
    }
    return true;
  };

  const isText = () => {
    if (!window.canvas || !activeObj || [ACTIVE_SELECTION].includes(activeObj.type)) return false;
    if (
      activeObj.type === TEXT_COMPONENT ||
      (!activeObj.id?.includes(CUSTOM_GROUP_ID) &&
        activeObj._objects?.some((o) => [TEXTBOX, ITEXT, CUSTOM_TEXT].includes(o.type)))
    )
      return true;
    return [TEXTBOX, ITEXT, CUSTOM_TEXT].includes(activeType);
  };

  const isChart = () => {
    if (!window.canvas || !activeObj) return false;
    return activeObj?.id?.includes(CHART);
  };

  const { showAlignmentSetting, showTransformComponent } = customSetting();
  const settingsComponent = [
    {
      key: 1,
      header: 'Transform',
      data: <TransformComponent />,
    },
  ];
  if (!showTransformComponent) settingsComponent.pop();

  if (isText() && activeType) {
    settingsComponent.push({
      key: 2,
      header: 'Text',
      data: <TextEditor />,
    });
  }

  if (hasColorSettings() && activeType) {
    settingsComponent.push({
      key: 3,
      header: 'Fill & Stroke',
      data: <AppearanceSettings />,
    });
  }

  if (isChart()) {
    settingsComponent.push({
      key: 4,
      header: 'Chart Settings',
      data: <ChartSettings />,
    });
  }

  settingsComponent.push({
    key: 5,
    header: 'Opacity',
    data: <OpacitySettings />,
  });

  if (hasColorSettings()) {
    settingsComponent.push({
      key: 6,
      header: 'Shadow',
      data: <ShadowSettings />,
    });
  }

  const settings = settingsComponent;
  return (
    <div className="settings-inside-toolbar">
      <div className={classnames('mo__component-setting')}>
        <div className="component-settings__wrapper">
          <span className="object-name">{objectName}</span>
        </div>
        {showAlignmentSetting && (
          <div className="alignment-wrapper">
            {/* <AlignmentSetting isShow isSetting /> */}
            <ObjectLayer />
          </div>
        )}

        <div className="details">
          {activeType ? (
            <Collapse
              bordered={false}
              expandIconPosition="end"
              className="collapse"
              defaultActiveKey={settings.map((s) => s.key)}
              expandIcon={({ isActive }) => (
                <div className="expand-icon">
                  <CaretRightOutlined style={{ fontSize: '17px' }} rotate={isActive ? 90 : 0} />
                </div>
              )}
            >
              {!activeObj?.isControlPoint &&
                settings.map((item) => (
                  <Panel key={item.key} header={item.header.toUpperCase()} className="item">
                    <div className="content">{item.data}</div>
                  </Panel>
                ))}
            </Collapse>
          ) : (
            <div />
          )}
        </div>
      </div>
    </div>
  );
};

export default ComponentSettings;
